var JS_LOADER = function() {
    //external scriptlere erişim olmadığnda(external site down olmuştur veya iatitest network gibi inernet erişim olmayan bir yerde uyg. deploy olmuştur)
    //script tagı ile bu js ler yüklenmeye çalıştığında sayfanın açılmasını bloke edebiliyor. Bunun önüne geçmek için bu şekilde kod ile yükleniyor.
    this.load = function(url, callback){
        var script = document.createElement('script');

        if(callback){
            script.onreadystatechange= function () {
                if (this.readyState == 'complete') callback();
            }
            script.onload= callback;
        }

        script.async = false; //this script should be load before document load.
        script.src = url;
        var s = document.getElementsByTagName('script')[0];
        s.parentNode.insertBefore(script, s);
    }

    this.loadTransferScripts = function(){
        JS_LOADER.load("//maps.google.com/maps/api/js?key="+Globals.Google.mapKey, function(){
            JS_LOADER.load("/dist/albilet/jquery-ui-1.13.1/jquery.ui.map.full.min.js", function(){
                JS_LOADER.load("/js/albilet/transfer/transferMap.js");
            })
        });
    }

    this.loadHotelScripts = function(){
        if(HotelResult.isHotelListNotEmpty){
            JS_LOADER.load("/js/albilet/hotel/hotelSearch.js")
        }
    }

    this.loadHotelDetailScripts = function(){
        JS_LOADER.load("//maps.google.com/maps/api/js?key="+Globals.Google.mapKey+"&libraries=places", function(){
            JS_LOADER.load("/dist/albilet/jquery-ui-1.13.1/jquery.ui.map.full.min.js", function(){
                JS_LOADER.load("/js/albilet/hotel/hotelSearch.js", function(){
                    JS_LOADER.load("/js/albilet/hotel/hotelDetail.js")
                })
            })
        });
    }

    return {
        load : load,
        loadTransfer:loadTransferScripts,
        loadHotel:loadHotelScripts,
        loadHotelDetail:loadHotelDetailScripts
    }
}();
